module.exports = __webpack_public_path__ + "img/beavers.f86851a8.png";